import { getBanner } from '@/request/api/home.js';
import { onMounted, reactive } from 'vue';
export default {
  name: 'SwpierTop',

  setup() {
    const state = reactive({
      images: []
    });
    onMounted(async () => {
      let {
        data: res
      } = await getBanner(); // console.log(res);

      state.images = res.banners;
    });
    return {
      state
    };
  }

};